import { connect } from 'react-redux';
import InvoiceOutstading from '../../../../views/Finance/Spp/LaporanKeu/InvoiceOutstading.laporankeu.view';
import { getAdjustmentJournal } from '../../../../states/thunks/finance.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetAdjustmentJournal: payload => dispatch(getAdjustmentJournal(payload)),
  };
}

export default connect(null, mapDispatchToProps)(InvoiceOutstading);
